import React, {FC} from "react";
import moment from "moment";
import {Space, Tag, Tooltip, Typography} from "antd";
import {BookingDunningStatus, DunningLevel} from "../../../../generated/graphql";
import i18n from "../../../../services/i18n";

// Getter statt Modul-Konstante (react-hot-loader, siehe BookingDunningsPanel)
const tr = () => i18n.containers.invoice.BookingDunnings;
const day = (date: string) => moment(date).format("DD.MM.");

type Props = {status?: Pick<BookingDunningStatus, "level" | "levelDate" | "nextLevel" | "nextDate" | "due" | "pausedUntil"> | null};

/** Spalte „Mahnstufe“ in Offene Zahlungen (#1517): aktuelle Stufe und wann die nächste dran ist */
const DunningStatusCell: FC<Props> = ({status}) => {
    if (!status || (!status.level && !status.nextLevel)) {
        return <Typography.Text type="secondary">–</Typography.Text>;
    }
    const levelName = (level: DunningLevel) => tr().levels[level]();
    let next: React.ReactNode = null;

    if (status.pausedUntil) {
        next = <Tag>{tr().list.paused({date: day(status.pausedUntil)})}</Tag>;
    } else if (status.nextLevel && status.nextDate) {
        next = status.due ? (
            <Tag color="red">{tr().list.due({level: levelName(status.nextLevel), date: day(status.nextDate)})}</Tag>
        ) : (
            <Typography.Text type="secondary">{tr().list.upcoming({level: levelName(status.nextLevel), date: day(status.nextDate)})}</Typography.Text>
        );
    }

    return (
        <Space direction="vertical" size={2}>
            {status.level && (
                <Tooltip title={status.levelDate ? moment(status.levelDate).format("DD.MM.YYYY") : undefined}>
                    <Tag color={status.level === DunningLevel.Reminder ? "blue" : "orange"}>
                        {levelName(status.level)}
                        {status.levelDate ? ` ${day(status.levelDate)}` : ""}
                    </Tag>
                </Tooltip>
            )}
            {next}
        </Space>
    );
};

export default DunningStatusCell;

/** Mahnstand einer Zeile aus GetUnpaidScheduledPayments; andere Listen laden ihn nicht */
export const dunningStatusOf = (row: unknown): Props["status"] => (row as {dunningStatus?: Props["status"]} | undefined)?.dunningStatus;
